import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClientesService } from 'src/app/services/clientes.service';
import { GruposService } from 'src/app/services/grupos.service';
import { LoginService } from 'src/app/services/login.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reporte-ventas',
  templateUrl: './reporte-ventas.component.html',
  styleUrls: ['./reporte-ventas.component.scss']
})
export class ReporteVentasComponent implements OnInit {
  enviroment = environment.BASE_URL;

  respuestGrupos:any;
  grupos;
  data:any;
  respuesta:any;
  pagos:any;
  respuestaGet:any;
  datosCliente;
  totalPagado = 0;

  formulario;

  fecha_inicio;
  fecha_fin;
  accesoPagos = 0;
  constructor(private _getGrupos: GruposService, private _get:ClientesService, private _getData:LoginService,
    private router:Router) { }

  ngOnInit(): void {
    this.getGrupos();
    this.getPagosReporte();
    this.getDataCliente();

    this.formulario = {
      'fecha_inicio':'',
      'fecha_fin':'',
    }
  }

  getDataCliente(){
    this._getData.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
          this.accesoPagos = this.datosCliente.acceso_pagos
          if(this.accesoPagos != 1){
            this.router.navigate(['clientes']);
          }
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  getGrupos(){
    this._getGrupos.getGruposNombre().subscribe(
      data => {
        this.respuestGrupos = data;
        if(this.respuestGrupos.success){
          this.grupos = this.respuestGrupos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPagosReporte(){
    this._get.getPagosReporte().subscribe(
      data => {
        this.respuesta = data;
        if(this.respuesta.success){
          this.pagos = this.respuesta.pagos;
          this.totalPagado = this.respuesta.totalPagado;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPagosGrupo(grupo, formaPago, tipoPago){

    if (this.formulario.fecha_inicio != null){
      this.fecha_inicio = this.formulario.fecha_inicio['year']+'-'+this.formulario.fecha_inicio['month']+'-'+this.formulario.fecha_inicio['day']
    }

    if (this.formulario.fecha_fin != null){
      this.fecha_fin = this.formulario.fecha_fin['year']+'-'+this.formulario.fecha_fin['month']+'-'+this.formulario.fecha_fin['day']
    }


    this.data = {
      'grupo':grupo,
      'formaPago':formaPago,
      'tipoPago':tipoPago,
      'fecha_fin':this.fecha_fin,
      'fecha_inicio':this.fecha_inicio,
    }


    this._get.getPagosGrupo(this.data).subscribe(
      data => {
        this.respuesta = data;
        if(this.respuesta.success){
          this.pagos = this.respuesta.pagos;
          this.totalPagado = this.respuesta.totalPagado;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  descargarExcel(grupo, formaPago, tipoPago){
    if (this.formulario.fecha_inicio != null){
      this.fecha_inicio = this.formulario.fecha_inicio['year']+'-'+this.formulario.fecha_inicio['month']+'-'+this.formulario.fecha_inicio['day']
    }

    if (this.formulario.fecha_fin != null){
      this.fecha_fin = this.formulario.fecha_fin['year']+'-'+this.formulario.fecha_fin['month']+'-'+this.formulario.fecha_fin['day']
    }

    window.location.replace(this.enviroment+'/api/descargarExcelPagos?grupo='+grupo+'&formaPago='+formaPago+'&tipoPago='+tipoPago+'&fecha_fin='+this.fecha_fin+'&fecha_inicio='+this.fecha_inicio);
  }

}
